
const header = {
  state: {
    indexPath:[]
  },
  mutations: {
    setIndexPath:(state,indexPath)=>{
      state.indexPath = indexPath;
    }
  },
  actions: {
    
  }
}

export default header



// WEBPACK FOOTER //
// ./src/store/modules/header.js